module.exports = __webpack_public_path__ + "img/1f426.607fc7f.svg";